module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-indicator-perfect-circle.da75f9949b204ea3e4d94d452fe609f8.svg";